import { render, staticRenderFns } from "./purchaseAdmin.vue?vue&type=template&id=95d29c36&scoped=true&"
import script from "./purchaseAdmin.vue?vue&type=script&lang=js&"
export * from "./purchaseAdmin.vue?vue&type=script&lang=js&"
import style0 from "./purchaseAdmin.vue?vue&type=style&index=0&id=95d29c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d29c36",
  null
  
)

export default component.exports